/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Confirm_Recovery_Code_SavedInputs */



/**
* | output |
* | --- |
* | "I have safely stored my recovery code and understand that I cannot access it again from this page." |
*
* @param {Auth_Confirm_Recovery_Code_SavedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_confirm_recovery_code_saved = /** @type {((inputs?: Auth_Confirm_Recovery_Code_SavedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Confirm_Recovery_Code_SavedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ich habe meinen Wiederherstellungscode sicher gespeichert und verstehe, dass ich nicht mehr auf dieser Seite darauf zugreifen kann.")
	return /** @type {LocalizedString} */ ("I have safely stored my recovery code and understand that I cannot access it again from this page.")
});